var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeline-container" },
    [
      _vm.tabs && _vm.tabs.length > 0 && _vm.filtersReady && !_vm.isDocument
        ? _c("timelinefilterstabs", {
            attrs: {
              activeTab: _vm.activeTab,
              tabs: _vm.tabs,
              counters: _vm.counters
            },
            on: {
              "update:activeTab": function(tab) {
                return (_vm.activeTab = tab)
              },
              applyFilter: _vm.applyFilter
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.useFilters && _vm.filtersReady && !_vm.isDocument
        ? _c("timelinefilters", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showFilter,
                expression: "showFilter"
              }
            ],
            attrs: { presetDate: _vm.presetDate },
            on: { applyFilter: _vm.applyFilter, resetFilter: _vm.resetFilter },
            model: {
              value: _vm.entitiesGroups,
              callback: function($$v) {
                _vm.entitiesGroups = $$v
              },
              expression: "entitiesGroups"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailFilters || _vm.isDocument
        ? _c("TimelineEmailFilters", {
            staticClass: "timeline-filters",
            attrs: { activeFilter: _vm.activeEmailFilter },
            on: { filterUpdate: _vm.handleEmailFilterUpdate }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAnnotationFilters
        ? _c("TimelineAnnotationFilters", {
            staticClass: "timeline-filters",
            attrs: {
              activeFilter: _vm.activeAnnotationFilter,
              overviewType: _vm.overviewType
            },
            on: { filterUpdate: _vm.handleAnnotationFilterUpdate }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cd-container mt-0 flex-column timeline-container",
          on: { scroll: _vm.onScroll }
        },
        [
          _c("section", { attrs: { id: "cd-timeline" } }, [
            _vm.incomingLogs && _vm.incomingLogs.length > 0
              ? _c("div", { staticClass: "incoming-events" }, [
                  _c("div", { staticClass: "cd-timeline-log--title" }, [
                    _vm.incomingLogs.length > 0
                      ? _c("div", { staticClass: "cd-timeline-day-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "cd-timeline-day-label semibold" },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.p__("Timeline", "A venir")
                                    ) +
                                    "\n                            "
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cd-timeline-more" }, [
                    !_vm.loaderIncoming
                      ? _c("div", { staticClass: "ml-6" }, [
                          _vm.pagination.incoming.seeMore
                            ? _c(
                                "a",
                                {
                                  staticClass: "link",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.fetch(false, true)
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Voir plus d'éléments d'activité"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "loader-container prelative aleft py-3"
                          },
                          [
                            _c("preloader", {
                              attrs: {
                                display: _vm.loaderIncoming,
                                size: "small",
                                background: false
                              }
                            })
                          ],
                          1
                        )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-column timeline-overflow-y",
                      class: {
                        "cd-timeline--overflow": _vm.isOverflowing(
                          _vm.orderedIncomingLogs
                        )
                      }
                    },
                    _vm._l(_vm.orderedIncomingLogs, function(log, indexLog) {
                      return _c(
                        "div",
                        {
                          key: indexLog,
                          class: {
                            "cd-timeline-log": true,
                            "cd-timeline-log--object": log.cardType === "object"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              class:
                                "cd-timeline-block block-" +
                                log.type +
                                " card-" +
                                log.cardType
                            },
                            [
                              _c(_vm.getComponent(log), {
                                tag: "component",
                                staticClass: "flex",
                                attrs: {
                                  oneLog: log,
                                  isDocument: _vm.isDocument,
                                  linkedtype: _vm.linkedtype,
                                  linkedid: _vm.linkedid,
                                  overviewType: _vm.overviewType
                                },
                                on: {
                                  changeLog: function(e) {
                                    return _vm.updateIncomingLog(e, log)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderedLogs && _vm.orderedLogs.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "past-events flex-column",
                    class: {
                      "cd-timeline--overflow": _vm.isOverflowing(
                        _vm.orderedLogs
                      )
                    }
                  },
                  _vm._l(_vm.orderedLogs, function(log, indexLog) {
                    return _c(
                      "div",
                      {
                        key: indexLog,
                        class: {
                          "cd-timeline-log": true,
                          "cd-timeline-log--object": log.cardType === "object",
                          "cd-timeline-log--annual": log.displayYear,
                          "cd-timeline-log--day": log.displayDate
                        }
                      },
                      [
                        log.displayYear
                          ? _c("div", { staticClass: "annual-line-block" }, [
                              _c("h2", { staticClass: "annual-line" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(log.displayYear) +
                                    "\n                        "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        log.displayDate
                          ? _c(
                              "div",
                              { staticClass: "cd-timeline-day-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cd-timeline-day-label semibold"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$filters.dateFormatter(
                                              log.timestamp,
                                              "NORMAL_MONTH",
                                              false
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: {
                              "cd-timeline-block": true,
                              "flex-level": log.cardType !== "object"
                            }
                          },
                          [
                            log.cardType !== "object"
                              ? _c("TimelineSystemIcon", {
                                  staticClass: "timeline-icon",
                                  attrs: { log: log }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(_vm.getComponent(log), {
                              key: log.objectid,
                              ref: _vm.getRefType(log),
                              refInFor: true,
                              tag: "component",
                              staticClass: "flex",
                              attrs: {
                                id: log.objectid,
                                isDocument: _vm.isDocument,
                                overviewType: _vm.overviewType,
                                linkedid: _vm.linkedid,
                                linkedtype: _vm.linkedtype,
                                oneLog: log,
                                isPinnable: "staff" !== _vm.linkedtype
                              },
                              on: {
                                changeLog: function(e) {
                                  return _vm.updateLog(e, log)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cd-timeline-more gray-60 fs-3" }, [
            !_vm.loader
              ? _c(
                  "div",
                  [
                    _vm.pagination.past.seeMore
                      ? _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__(
                              "timeline.Timeline.view_more_activity_items"
                            ),
                            type: "tertiary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.fetch(true, false)
                            }
                          }
                        })
                      : _c("p", { staticClass: "m-0 semibold pl-5" }, [
                          _vm._v(_vm._s(_vm.errorMessage))
                        ])
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "loader-container prelative mt-5 py-3" },
                  [
                    _c("preloader", {
                      attrs: {
                        display: _vm.loader,
                        size: "small",
                        background: false
                      }
                    })
                  ],
                  1
                )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }